module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921124149_T.052415b2.jpg";